import React from "react";
import useProductName from "brand-customization/useProductName";
import { Trans, useTranslation } from "react-i18next";
import { DocumentTitle, PageHeader } from "components/common";
const OKTA_PRODUCT_NAME = "Okta";
const OidcConfiguration = () => {
  const { t } = useTranslation("enterprise_authentication");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("cloud_oidc_configuration.title") }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("cloud_oidc_configuration.title"), subpage: true }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "cloud_oidc_configuration.description",
      values: { productName },
      components: { oktaLink: /* @__PURE__ */ React.createElement("a", { href: "https://www.okta.com" }, OKTA_PRODUCT_NAME), em: /* @__PURE__ */ React.createElement("em", null) }
    }
  ))), /* @__PURE__ */ React.createElement("span", null, t("cloud_oidc_configuration.required", { productName }))));
};
export default OidcConfiguration;
